export default __webpack_public_path__ + "static/media/crowdkeep branco (high res).87fedeff.png";